<template>
  <div class="w-full lg:mt-[50px] bg-grey-10 text-base leading-[22px] md:leading-6 font-normal">
    <div class="container py-3 md:py-4 text-grey-40">
      <StaticSearchLink :to="{ name: 'home' }">Home</StaticSearchLink>
      <span class="px-2 md:px-3">&gt;</span>
      <template v-for="(page, index) in hierarchy" :key="page">
        <template v-if="(index < hierarchy.length-1)">
          <StaticSearchLink v-if=page.url :to="page.url">
            {{ page.name }}
          </StaticSearchLink>
          <span v-else >{{ page.name }}</span>
          <span class="px-2 md:px-3">&gt;</span>
        </template>

        <span v-else class="font-semibold">{{ page.name }}</span>
      </template>
    </div>
  </div>
</template>

<script>

import StaticSearchLink from './StaticSearchLink.vue';

export default {
    name: 'PageBreadcrumb',
    components: {
        StaticSearchLink,
    },
    props: {
        hierarchy: {
            type: Array,
            default: ['Home'],
        },
    },
};
</script>
